
import { useState } from 'react';
import BookingChoiceModal from '../../../components/feature/BookingChoiceModal';

const CTA2Section = () => {
  const [showBookingChoice, setShowBookingChoice] = useState(false);

  return (
    <>
      <section className="bg-[#83B328] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Process Steps */}
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                See How Simple It Is to Get Started
              </h2>
              <p className="text-xl text-green-100 mb-8">
                No complicated processes. No hidden fees. Just straightforward, professional service with instant response times.
              </p>

              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="flex-shrink-0 w-12 h-12 bg-white rounded-full flex items-center justify-center text-[#24820C] font-bold text-xl">
                    1
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold text-white mb-2">Choose Your Booking Type</h3>
                    <p className="text-green-100">Pick an in-person evaluation or instant service booking</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 w-12 h-12 bg-white rounded-full flex items-center justify-center text-[#24820C] font-bold text-xl">
                    2
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold text-white mb-2">Get Instant Response</h3>
                    <p className="text-green-100">Receive immediate confirmation and schedule your service</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 w-12 h-12 bg-white rounded-full flex items-center justify-center text-[#24820C] font-bold text-xl">
                    3
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold text-white mb-2">Relax While We Work</h3>
                    <p className="text-green-100">We handle everything from start to finish with professional care</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Booking Card */}
            <div className="bg-white rounded-lg shadow-xl p-8">
              <div className="text-center mb-6">
                <div className="inline-block bg-red-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
                  ⚡ Instant Response Times
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  Ready to Transform Your Property?
                </h3>
                <p className="text-gray-600">
                  Choose how you'd like to get started and book today
                </p>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-center text-gray-700">
                  <i className="ri-check-line text-[#24820C] text-xl mr-3"></i>
                  <span>In-person evaluation or instant booking</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <i className="ri-check-line text-[#24820C] text-xl mr-3"></i>
                  <span>Immediate booking confirmation</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <i className="ri-check-line text-[#24820C] text-xl mr-3"></i>
                  <span>Fast, professional service</span>
                </div>
              </div>

              <div className="space-y-4">
                <button 
                  onClick={() => setShowBookingChoice(true)}
                  className="w-full bg-[#24820C] hover:bg-[#1a5f09] text-white font-bold py-4 px-6 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                >
                  Book Now
                </button>

                <div className="text-center">
                  <p className="text-sm text-gray-500 mb-2">Or call us directly</p>
                  <a 
                    href="#" 
                    className="call-trigger text-[#24820C] hover:text-[#1a5f09] font-semibold text-lg"
                    data-phone="4438191521"
                  >
                    (443) 819-1521
                  </a>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-200 text-center">
                <p className="text-sm text-gray-500">
                  <i className="ri-time-line mr-1"></i>
                  Instant response • Professional service • Quality guaranteed
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookingChoiceModal isOpen={showBookingChoice} onClose={() => setShowBookingChoice(false)} />
    </>
  );
};

export default CTA2Section;
